// Language codes (ISO Standard)
export var LanguageCodeEnum;
(function (LanguageCodeEnum) {
    LanguageCodeEnum["EN"] = "en";
    LanguageCodeEnum["NL"] = "nl"; // Add more as needed
})(LanguageCodeEnum || (LanguageCodeEnum = {}));
// Language display names
export var LanguageNameEnum;
(function (LanguageNameEnum) {
    LanguageNameEnum["EN"] = "English";
    LanguageNameEnum["NL"] = "Dutch";
})(LanguageNameEnum || (LanguageNameEnum = {}));
